const CONSTANTS = require('frontend-controller/lib/constants')

module.exports = {
    extends: [
        '/',
        'base',
        'tabStrip',
        'tabStrip',
    ],

    actions: {
        addTab: {
            source: {
                tab: {
                    componentData: {
                        component: [
                            'templates',
                            'core',
                            'tabStrip',
                            'tab'
                        ],
                        config: {
                            lastMileSelector: '.subTabs'
                        },
                    },
                }
            }
        },

        addTabForRoute: {
            type: CONSTANTS.COMPONENT.ACTION.TYPE.TAB,
            source: {},
            target: {
                element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF,
            }
        }
    },

    config: {
        isMainNav: false,
        invertedColors: false,
        cycleThroughTabsViaMouseWheel: true,
        oneLineTabs: true,
        oneLineTabsConfig: {
            transitionAnimation: false,
            additionalOffsetX: -100,
            selectors: {
                wrapper: '> .tabs > .subTabContainer > .subTabsWrapper',
                container: '> .subTabs',
                lastMile: '.subTabs'
            }
        },
    },

    methods: {

        showEdit(context, entityID, resourceRegister){
            const baseActionKey = `showEdit_${context}`
            const actionKey = `${baseActionKey}_inEffect_${entityID}`

            if(this.actions[actionKey]){
                return this.performAction(actionKey)
            } else {
                return this.performAndStoreAction(
                    actionKey,
                    this.prepareAction(baseActionKey, entityID, resourceRegister),
                    false
                )
            }
        },

        postDeleteRecord(callerComponent, buttonContext, entityID, entityData){
            // NOTE: overwrite if necessary
            this.closeTabsByEntity(buttonContext, entityID)
        },

        closeTabsByEntity(buttonContext, entityID){
            // NOTE: overwrite if necessary
            // close tab if necessary
            if(buttonContext && entityID){
                const actionKey = `showEdit_${buttonContext}_inEffect_${entityID}`
                const tabRegisterSecret = ((this.actions[actionKey] || {}).tabConnection || {}).tabRegisterSecret
                if(tabRegisterSecret !== undefined){
                    this.removeTab(tabRegisterSecret)
                }
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const {
                entity,
                entityID,
                isDelete,
            } = ((message || {}).data || {})

            if(isDelete && entity && entityID){
                this.postDeleteRecord(this, entity, entityID)
            }
        },
    },

    handlers: [
        {
            name: 'heartbeat.resourceChanged',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
        {
            name: 'heartbeat.reconnect',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
    ]
}